import React, { Component, Fragment } from "react"

//Component
import FileUpload from "../../components/FileUpload/FileUpload"
import Audit from "../../components/Common/audit"

import {
  DevelopmentServices,
  CustomerServices,
  SystemServices,
  StyleServices
} from "../../services"
import Async from "react-select"
import "react-select/dist/react-select.css"
import Modal from "react-responsive-modal"

//components
import Loading from "../../components/Common/Loading"
import Field from "../../components/Common/Field/Field"
import CustomerDeptSelect from "../../components/Field/CustomerDeptSelect"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import Button from "../../components/Buttons/Button"
import Picky from "react-picky"
import "react-picky/dist/picky.css" // Include CSS
//Assets
var letters = (function () {
  // object to expose as public properties and methods such as clock.now
  var pub = {}
  var letterArray = []

  //letters.increment('a')
  pub.increment = function (c) {
    letterArray = c.split("")

    if (isLetters(letterArray)) {
      localStorage.setItem("letter", next(c))
      return next(c)
    } else {
      throw new Error("Letters Only")
    }
  }

  function isLetters(arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].toLowerCase() !== arr[i].toUpperCase()) {
      } else {
        return false
      }
    }
    return true
  }

  function next(c) {
    var u = c.toUpperCase()
    if (same(u, "Z")) {
      var txt = ""
      var i = u.length
      while (i--) {
        txt += "A"
      }
      return txt + "A"
    } else {
      var p = ""
      var q = ""
      if (u.length > 1) {
        p = u.substring(0, u.length - 1)
        q = String.fromCharCode(p.slice(-1).charCodeAt(0))
      }
      var l = u.slice(-1).charCodeAt(0)
      var z = nextLetter(l)
      if (z === "A") {
        return p.slice(0, -1) + nextLetter(q.slice(-1).charCodeAt(0)) + z
      } else {
        return p + z
      }
    }
  }

  function nextLetter(l) {
    if (l < 90) {
      return String.fromCharCode(l + 1)
    } else {
      return "A"
    }
  }

  function same(str, char) {
    var i = str.length
    while (i--) {
      if (str[i] !== char) {
        return false
      }
    }
    return true
  }

  //API

  return pub
})()
class DevelopmentBNumber extends Component {
  state = {
    action: "",
    qr: null,
    quality: "",
    GSM: "",
    imageForModal: "",
    styleId: "",
    fabricInfo: [],
    openModal: false,

    _id: "",
    bNumber: {
      dateOfSubmission: null,
      customer: null,
      customerDepartmentId: null,
      qr: "",
      baseRefNumber: "",
      refImages: [],
      magnumStyleId: null,
      fabric: null,
      // customer : null,
      // department : null,
      finishedWidth: "",
      reportStatus: null,
      failedText: "",
      bNumberRefernce: [],
      testingLab: null,
      typeOfWash: null,
      typeOfTest: [],
      slippageSeam: null
    },
    departmentName: "",
    customerName: "",
    styleOptions: [],
    bnumberOptions: {},
    fabricValues: {},
    styleValues: {},
    washValues: [],
    disabled: false,
    fabQuality: [],
    classificationOfFabrics: [],
    compositionFab: []
  }

  componentWillMount = () => {
    let action, _id;
    if (this.props.location.state) {
      action = this.props.location.state.action
      _id = this.props.location.state._id
    }
    else {
      const urlParams = new URLSearchParams(this.props.location.search)      
      action = urlParams.get("action")
      _id = urlParams.get("_id")
      this.props.history.replace('/BNumber', {
        action, _id, hash: false
      })

    }
    this.setState({
      action,
      _id
    })
    localStorage.setItem("letter", "a")
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({
            customerList: response.text.data,
            customerId: response.text.data[0]._id,
            departmentId: response.text.data[0].departmentId
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
    if (action === "add") {
      DevelopmentServices.generateQRBNumber()
        .then(response => {
          if (response.status === 200) {
            let bNumber = { ...this.state.bNumber }

            bNumber.qr = response.text.data.qr
            bNumber.baseRefNumber = response.text.data.baseRefNumber
            bNumber.dateOfSubmission = new Date()
            bNumber.bNumberRefernce.push({
              bNumberRef: bNumber.baseRefNumber,
              fabricId: null,
              greigeMill: null,
              processMill: null,
              linkToFabric: false
            })
            this.setState({ bNumber })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      if (action === "view") {
        this.setState({
          disabled: true
        })
      }
      if ((action === "edit" || action === "view") && _id !== "") {
        DevelopmentServices.getBNumber(_id)
          .then(res => {
            if (res.status === 200) {
              let bNumber = { ...this.state.bNumber }
              Object.keys(bNumber).forEach(function (key) {
                if (res.text.data[key] !== undefined) {
                  bNumber[key] = res.text.data[key]
                }
              })

              if (res.text.data.fabric !== null) {
                this.getFabricById(res.text.data.fabric)
              }

              res.text.data.bNumberRefernce.map(data => {
                if (data.fabricId !== null) {
                  this.getFabricById(data.fabricId)
                }
              })

              this.setState({
                bNumber,
                fabricValues: res.text.data.fabricValues
              })
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
      }
    }

    this.getFabrics("")

    //List of styles
    StyleServices.SearchStyle()
      .then(response => {
        if (response.status === 200) {
          let styleOptions = [...this.state.styleOptions]
          response.text.data.map(data =>
            styleOptions.push({ value: data._id, label: data.styleNumber })
          )
          this.setState({
            styleOptions
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))

    //Get BNumber Predefind values
    StyleServices.getBNumberPrefilldData()
      .then(response => {
        if (response.status === 200) {
          this.setState({
            bnumberOptions: response.text.data
          })
        }
      })
      .catch(error => {
        // alert("Something Went wrong...Try Again Later")
      })

    //Get Fabric Prefilled Data
    DevelopmentServices.prefillFabricDetails()
      .then(response => {
        if (response.message === "Operation Successful") {
          let fabQuality = [...this.state.fabQuality]
          let classificationOfFabrics = [...this.state.classificationOfFabrics]
          let compositionFab = [...this.state.compositionFab]
          response.data.Fabric.BASICQUALITY.map(data =>
            fabQuality.push({ value: data.value, label: data.label })
          )
          response.data.Fabric.CLASSIFICATIONOFFABRIC.map(data =>
            classificationOfFabrics.push({
              value: data.value,
              label: data.label
            })
          )
          response.data.Fabric.COMPOSITION.map(data =>
            compositionFab.push({ value: data.value, label: data.label })
          )
          this.setState({
            fabQuality,
            classificationOfFabrics,
            compositionFab
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  componentDidMount() {
    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  componentDidUpdate() {
    localStorage.setItem("letter", "a")
  }

  addBNumber = e => {
    e.preventDefault()

    let bNumber = { ...this.state.bNumber }

    if (this.state.action == "edit") {
      bNumber._id = this.state._id
    }
    if (bNumber.fabric == null ) {
        this.props.getalertMessage("error", "Please fill mandatory fields")
     } else {
      // bNumber.fabric = bNumber.fabric ? bNumber.fabric.value : null;
      if (bNumber.magnumStyleId !== null && typeof bNumber.magnumStyleId === "object")
        bNumber.magnumStyleId = bNumber.magnumStyleId.value
      // bNumber.typeOfTest = bNumber.typeOfTest ? bNumber.typeOfTest.value : null;

      bNumber.bNumberRefernce = this.state.bNumber.bNumberRefernce.map(data => {
        data.fabricId = data.fabricId !== null ? ((typeof data.fabricId === "object" && data.fabricId.value) || data.fabricId) : data.fabricId
        data.greigeMill =
          data.greigeMill !== null ? ((typeof data.greigeMill === 'object' && data.greigeMill.value) || data.greigeMill) : data.greigeMill
        data.processMill =
          data.processMill !== null ? ((typeof data.processMill === "object" && data.processMill.value) || data.processMill) : data.processMill
        data.linkToFabric = data.linkToFabric
        return data
      })


      DevelopmentServices.createBNum(bNumber)
        .then(response => {
          if (response.status === 200) {
            this.props.getalertMessage("success", response.text.message)
            if (response.text.data) {
              this.setState({ _id: response.text.data._id, bNumber: { ...this.state.bNumber, _id: response.text.data._id } })
            }
            // this.props.history.push("/list", { moduleName: "BNUMBER" });
          } else if (response.status == 401) {
            this.props.unauthorisedFunc()
          } else {
            this.props.getalertMessage("error", response.text.message)
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
      }
  }

  getFabrics = value => {
    if (value !== null) {
      DevelopmentServices.getFabricNumber(value)
        .then(response => {
          if (response.status == 200) {
            //  let fabricInfo = [...this.state.fabricInfo]
            //  if(fabricInfo.length > 0){
            //    response.text.data.map((data) =>{
            //    fabricInfo.map((fabric) =>{
            //     if(fabric.value !== data.value){
            //       fabricInfo.push({...data})
            //     }
            //    })
            //  })}
            //  else{
            //  fabricInfo = [...this.state.fabricInfo,...response.text.data]
            //  }
            this.setState({
              fabricInfo: [...response.text.data]
            })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  getFabricById = value => {
    DevelopmentServices.getFabricbyId(value)
      .then(response => {
        if (response.status == 200) {
          let fabricInfo = [...this.state.fabricInfo]
          fabricInfo.push({ ...response.text.data })
          this.setState({
            fabricInfo
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getMagnumStyleNo = value => {
    StyleServices.SearchStyle(value)
      .then(response => {
        if (response.status == 200) {
          let jsonData = []
          response.text.data.map(info => {
            let objData = {}
            objData.label = info.styleNumber
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ styleOptions: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  getTypeBStyleNo = value => {
    StyleServices.getBNumberPrefilldData(value)
      .then(response => {
        if (response.status == 200) {
          let jsonData = []
          response.data.map(info => {
            let objData = {}
            objData.label = info.styleNumber
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ bnumberOptions: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  getGreigeBStyleNo = value => {
    StyleServices.getBNumberPrefilldData(value)
      .then(response => {
        if (response.status == 200) {
          let jsonData = []
          response.text.data.map(info => {
            let objData = {}
            objData.label = info.styleNumber
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ bnumberOptions: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  getProcessBStyleNo = value => {
    StyleServices.getBNumberPrefilldData(value)
      .then(response => {
        if (response.status == 200) {
          let jsonData = []
          response.text.data.map(info => {
            let objData = {}
            objData.label = info.styleNumber
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ bnumberOptions: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getBuyer = e => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.message === "all customer details") {
          let jsonData = []
          response.data.map((info, index) => {
            let objData = {}
            objData.label = info.customerName
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ customerInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getDepartment = e => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.message === "all customer details") {
          let jsonData = []
          response.data.map((info, index) => {
            let objData = {}
            objData.label = info.departmentName
            objData.value = info.departmentId
            jsonData.push(objData)
          })
          this.setState({ departmentInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  getSupplier = e => {
    SystemServices.listSystemSupplier()
      .then(response => {
        if (response.message === "Operation Successful") {
          let jsonData = []
          response.data.map((info, index) => {
            let objData = {}
            objData.label = info.supplierName
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ supplierInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getWashType = e => {
    DevelopmentServices.getPrefillInfoForBN()
      .then(response => {
        if (response.message === "Operation Successful") {
          let jsonData = []
          response.data.Style.LAUNDRYTYPE.map((info, index) => {
            let objData = {}
            objData.label = info.name
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ washTypeInfo: jsonData }, function () { })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  getgarmentType = e => {
    DevelopmentServices.getPrefillInfoForBN()
      .then(response => {
        if (response.message === "Operation Successful") {
          let jsonData = []
          response.data.Style.GARMENTTYPE.map((info, index) => {
            let objData = {}
            objData.label = info.name
            objData.value = info._id
            jsonData.push(objData)
          })
          this.setState({ garmentInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  changeStyleNo = style => {
    let bNumber = { ...this.state.bNumber }
    if (style !== null) {
      StyleServices.getStyleInfo(style.value)
        .then(response => {
          if (response.status === 200) {
            bNumber.magnumStyleId = style.value
            bNumber.customer = response.text.data.customer
            bNumber.customerDepartmentId =
              response.text.data.customerDepartmentId
            this.setState({ bNumber })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      bNumber.magnumStyleId = null
      bNumber.customer = null
      bNumber.customerDepartmentId = null
      this.setState({ bNumber })
    }
  }

  changetypeOfTest = typeOfTest => {
    let bNumber = { ...this.state.bNumber }
    bNumber.typeOfTest = typeOfTest
    this.setState({ bNumber })
    //console.log(bNumber.typeOfTest, "bNumber")
  }
  changeGreige = greigemill => {
    this.setState({ greigemill })
  }
  changeProcess = processmill => {
    this.setState({ processmill })
  }
  changeFabric = async fabric => {
    let bNumber = { ...this.state.bNumber }
    if (fabric !== null) {
      await this.getFabricById(fabric.value)
      await DevelopmentServices.getSpecificFabric(fabric.value)
        .then(response => {
          if (response.status == 200) {
            bNumber.fabric = fabric.value
            bNumber.bNumberRefernce.length > 0 &&
              (bNumber.bNumberRefernce[0].fabricId = fabric.value)
            this.setState({
              fabricValues: response.text.data,
              bNumber
            })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      bNumber.fabric = null

      await this.setState({
        bNumber,
        fabricValues: {}
      })
    }
  }

  changeWashType = washType => {
    this.setState({ washType })
  }
  changeGarmentType = garmentType => {
    this.setState({ garmentType })
  }

  changeBuyer = buyer => {
    this.setState({ buyer })
  }

  changeDepartment = department => {
    this.setState({ department })
  }

  changeSupplier = supplier => {
    this.setState({ supplier })
  }

  __handleChange = (name, value, index) => {
    let bNumber = { ...this.state.bNumber }
    bNumber.bNumberRefernce[index][name] = value
    this.setState({ bNumber })
    localStorage.setItem("letter", "a")
  }
  //Jayaprakash E

  increasebNumberRefernce = () => {
    let bNumber = { ...this.state.bNumber }
    const item = {
      bNumberRef: bNumber.baseRefNumber,
      fabricId: null,
      greigeMill: null,
      processMill: null,
      linkToFabric: false
    }
    bNumber.bNumberRefernce = [...bNumber.bNumberRefernce, item]
    this.setState({ bNumber })
    localStorage.setItem("letter", "a")
  }

  decreasebNumberRefernce = index => {
    let bNumber = { ...this.state.bNumber }
    localStorage.setItem("letter", "a")
    bNumber.bNumberRefernce.splice(index, 1)
    this.setState({ bNumber })
  }

  updateLinkValue = (name, value, index) => {
    let bNumber = { ...this.state.bNumber }
    bNumber.bNumberRefernce[index][name] = value
    this.setState({ bNumber })
  }

  addReportStatus = e => {
    let bNumber = { ...this.state.bNumber }
    bNumber.reportStatus = e.target.value == "failed" ? false : true
    this.setState({ bNumber })
  }
  imageUpload = e => {
    this.setState(
      { images: this.state.images.concat(e.target.files[0]) },
      function () {
        let a = []
        this.state.images.map((image, index) => {
          let b = {}
          b = image
          b.imageName = `Sketch${++index}`
          b.imageDescription = ""
          a.push(b)
        })
        this.setState({ images: a })
      }
    )
  }
  imageInfo = (image, index) => {
    this.setState({ imageInfo: image, imageIndex: index })
  }
  uploadNewImage = e => {
    let b = {}
    b = e.target.files[0]
    b.imageName = this.state.imageInfo.imageName
    b.imageDescription = this.state.imageInfo.imageDescription
    this.setState({ uploadNewImage: b })
  }

  updateImage = () => {
    this.state.images.map((image, index) => {
      if (index === this.state.imageIndex) {
        this.state.images[index] =
          this.state.uploadNewImage !== ""
            ? this.state.uploadNewImage
            : this.state.imageInfo
      }
    })
  }

  changeImageName = value => {
    let a = this.state.imageInfo
    a.imageName = value
    this.setState({ imageInfo: a })
  }

  changeImageDescription = value => {
    let a = this.state.imageInfo
    a.imageDescription = value
    this.setState({ imageInfo: a })
  }

  removeImage = (image, indexVal) => {
    let a = this.state.images
    a.splice(indexVal, 1)
    this.setState({ images: a })
  }

  getRefImages = refImages => {
    let bNumber = { ...this.state.bNumber }
    bNumber.refImages = refImages
    this.setState({
      bNumber
    })
  }

  updateValue = (name, value) => {
    let bNumber = { ...this.state.bNumber }
    if (!Array.isArray(value)) {
      value = [value]
    }
    bNumber[name] = value
    this.setState({ bNumber })
  }

  _handleCustDeptChange = (index, customer, customerDepartmentId) => {
    let bNumber = { ...this.state.bNumber }
    bNumber.customer = customer
    bNumber.customerDepartmentId = customerDepartmentId
    this.setState({ bNumber })
  }
  render() {
    const {
      bNumber,
      failed,
      styleOptions,
      bnumberOptions,
      fabricInfo,
      fabricValues,
      styleValues,
      fabQuality,
      classificationOfFabrics,
      compositionFab
    } = this.state
    //console.log(bnumberOptions, "bnumberOptions")
    //console.log(bNumber.typeOfTest, "bNumber")

    if (Object.keys(bnumberOptions).length > 0) {
      return (
        <Fragment>
          <div class="right-section  remove-scroll-for-right">
            <div class="row nopadding">
              <form id="first">
                <div class="col-md-12 nopadding">
                  <div
                    class="card-filter meeting-min-con"
                    style={{ marginBottom: "0.5%" }}
                  >
                    <div class="row">
                      <div class="col-md-12 product-form nopadding">
                        <div className="no-padding  left-content-section">
                          <div className="col text-center bg-color padding-bottom-bg">
                            <h4 className="text-green font-lg font-weight-bold mt-2">
                              {this.state.bNumber.baseRefNumber}
                            </h4>
                            <div className="img-responsive-fill border-1 inputWrapper mt-2">
                              <img src={this.state.bNumber.qr} />
                            </div>
                          </div>
                        </div>
                        <div className="product-form overflow-scroll right-content-section">
                          <PageHeader
                            history={this.props.history}
                            header="B number"
                          />
                          <Audit _id={this.state._id} />
                          <div class="col-md-12 nopadding">
                            <div class="col-md-5 nopadding">
                              <div class="ib-list-view listFieldWrapper">
                                <ul class="main-list mb-0">
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Submission Date
                                      </li>
                                      <li>
                                        <Field
                                          isFormGroup={false}
                                          inputType="date"
                                          inputName="dateOfSubmission"
                                          value={bNumber.dateOfSubmission}
                                          onChange={this.updateValue}
                                          disabled={this.state.disabled}
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Fabric<span class="text-danger madatory-asterisk">*</span>
                                      </li>
                                      <li>
                                        <div class="custom-async-select">
                                          <Async
                                            value={this.state.bNumber.fabric}
                                            onInputChange={this.getFabrics}
                                            onChange={this.changeFabric}
                                            placeholder="Search Fabric"
                                            options={fabricInfo}
                                            onSelectResetsInput={false}
                                            disabled={this.state.disabled}
                                            onBlurResetsInput={false}
                                          />
                                        </div>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Count & Construction
                                      </li>
                                      <li>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="countConstruction"
                                          value={
                                            Object.keys(fabricValues).length > 0
                                              ? fabricValues.count.warp +
                                              "*" +
                                              fabricValues.count.weft +
                                              "/" +
                                              fabricValues.construction.warp +
                                              "*" +
                                              fabricValues.construction.weft
                                              : ""
                                          }
                                          readOnly
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Classification of fabric
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="cofabric"
                                          value={
                                            fabricValues.classificationOfFabric
                                          }
                                          readOnly
                                          disabled
                                        >
                                          <option value="">Select</option>
                                          {classificationOfFabrics.map(
                                            value => (
                                              <option value={value.value}>
                                                {value.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Quality{" "}
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="fabquality"
                                          value={fabricValues.quality}
                                          readOnly
                                          disabled
                                        >
                                          <option value="style">Select</option>
                                          {fabQuality.map(value => {
                                            return (
                                              <option value={value.value}>
                                                {value.label}
                                              </option>
                                            )
                                          })}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Composition{" "}
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="composition"
                                          value={fabricValues.composition}
                                          readOnly
                                          disabled
                                        >
                                          <option value="style">Select</option>
                                          {compositionFab.map(value => (
                                            <option value={value.value}>
                                              {value.label}
                                            </option>
                                          ))}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        GSM/OZ
                                      </li>
                                      <li>
                                        <input
                                          type="text"
                                          name="gsm"
                                          readOnly
                                          className="form-control"
                                          value={
                                            fabricValues.gsm &&
                                              fabricValues.width
                                              ? `${fabricValues.gsm}/${fabricValues.width}`
                                              : ""
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Finished Width{" "}
                                      </li>
                                      <li>
                                        <input
                                          type="text"
                                          name="fabquality"
                                          className="form-control"
                                          onChange={e =>
                                            this.updateValue(
                                              "finishedWidth",
                                              e.target.value
                                            )
                                          }
                                          value={
                                            this.state.bNumber.finishedWidth
                                          }
                                          disabled={this.state.disabled}
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="col-md-5 nopadding">
                              <div class="ib-list-view listFieldWrapper">
                                <ul class="main-list">
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">Style</li>
                                      <li>
                                        <div class="custom-async-select">
                                          <Async
                                            value={
                                              this.state.bNumber.magnumStyleId
                                            }
                                            onInputChange={
                                              this.getMagnumStyleNo
                                            }
                                            name={'magnumStyleId'}
                                            onChange={this.changeStyleNo}
                                            placeholder="Select Style"
                                            options={styleOptions}
                                            disabled={this.state.disabled}
                                            onSelectResetsInput={false}
                                            onBlurResetsInput={false}
                                          />
                                        </div>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <CustomerDeptSelect
                                        options={this.state.customerList}
                                        value={`${this.state.bNumber.customer}-${this.state.bNumber.customerDepartmentId}`}
                                        onChange={this._handleCustDeptChange}
                                        disabled={this.state.disabled}
                                        pageName="bNumber"
                                        notMandate="true"
                                      />
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Types of test{" "}
                                      </li>
                                      <li>
                                        <Picky
                                          value={this.state.bNumber.typeOfTest}
                                          options={bnumberOptions.TYPESOFTEST}
                                          onChange={val =>
                                            this.updateValue("typeOfTest", val)
                                          }
                                          className={"picky-custom-width"}
                                          open={false}
                                          valueKey="value"
                                          labelKey="label"
                                          multiple={true}
                                          includeSelectAll={true}
                                          manySelectedPlaceholder={"%s selected"}
                                          allSelectedPlaceholder={"%s selected"}
                                          includeFilter={true}
                                          dropdownHeight={300}
                                          disabled={this.state.disabled}
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Testing Lab
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="testingLab"
                                          onChange={e =>
                                            this.updateValue(
                                              "testingLab",
                                              e.target.value
                                            )
                                          }
                                          value={this.state.bNumber.testingLab}
                                          disabled={this.state.disabled}
                                        >
                                          <option value="style">Select</option>
                                          {bnumberOptions.TESTINGLAB.map(
                                            value => (
                                              <option value={value.value}>
                                                {value.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Slippage Seam
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="slippageSeam"
                                          onChange={e =>
                                            this.updateValue(
                                              "slippageSeam",
                                              e.target.value
                                            )
                                          }
                                          value={
                                            this.state.bNumber.slippageSeam
                                          }
                                          disabled={this.state.disabled}
                                        >
                                          <option value="style">Select</option>
                                          {bnumberOptions.SLIPPAGESEAM.map(
                                            value => (
                                              <option value={value.value}>
                                                {value.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>

                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Type of Wash
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="quality"
                                          value={this.state.bNumber.typeOfWash}
                                          disabled={this.state.disabled}
                                          onChange={e =>
                                            this.updateValue(
                                              "typeOfWash",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="style">Select</option>
                                          {bnumberOptions.TYPEOFWASH.map(
                                            value => (
                                              <option value={value.value}>
                                                {value.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li className="text-right pt-2">
                                        Report Status{" "}
                                      </li>
                                      <li>
                                        <select
                                          className="form-control select-height customized-height-inputform"
                                          name="classificationOfFabric"
                                          onChange={e =>
                                            this.addReportStatus(e)
                                          }
                                          disabled={this.state.disabled}
                                          value={
                                            this.state.bNumber.reportStatus ===
                                              null
                                              ? ""
                                              : this.state.bNumber.reportStatus
                                                ? "success"
                                                : "failed"
                                          }
                                        >
                                          <option value="">Select</option>
                                          <option value="success">
                                            Success
                                          </option>
                                          <option value="failed">Failed</option>
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  {!this.state.bNumber.reportStatus &&
                                    this.state.bNumber.reportStatus !==
                                    null && (
                                      <li>
                                        <ul>
                                          <li className="text-right pt-2" />
                                          <li>
                                            <span className="font-apply-li">
                                              if failed :{" "}
                                            </span>
                                            <textarea
                                              className="form-control"
                                              rows="2"
                                              cols="50"
                                              name='failed'
                                              disabled={this.state.disabled}
                                              onChange={e =>
                                                this.updateValue(
                                                  "failedText",
                                                  e.target.value
                                                )
                                              }
                                              value={bNumber.failedText}
                                            />
                                            {/* <input
                                              type="text"
                                              name="failed"
                                              className="form-control"
                                              value={bNumber.failedText}
                                              onChange={e =>
                                                this.updateValue(
                                                  "failedText",
                                                  e.target.value
                                                )
                                              }
                                              disabled={this.state.disabled}
                                            /> */}
                                          </li>
                                        </ul>
                                      </li>
                                    )}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 col">
                            <table class="table table-borderless btable">
                              <tbody>
                                <tr>
                                  <td width="20%" className="font-apply-li">
                                    B number
                                  </td>
                                  <td width="20%" className="font-apply-li">
                                    Fabric Number
                                  </td>
                                  <td width="20%" className="font-apply-li">
                                    Greige Mill
                                  </td>
                                  <td width="20%" className="font-apply-li">
                                    Process Mill
                                  </td>
                                  {/* <td width="15%" className="font-apply-li">
                                    Link to Fabric
                                  </td> */}
                                  <td width="5%">
                                    <Button
                                      buttonType={"add"}
                                      onClick={this.increasebNumberRefernce}
                                    />
                                  </td>
                                </tr>
                                {this.state.bNumber.bNumberRefernce.map(
                                  (value, index) => (
                                    <tr key={index}>
                                      <td className="form-inline">
                                        <div>
                                          <input
                                            type="text"
                                            readOnly={true}
                                            name="bnumber"
                                            class="form-control col-8"
                                            value={value.bNumberRef}
                                          />
                                          <span className="px-2 font-apply-li">
                                            {index === 0
                                              ? String.fromCharCode(65 + index)
                                              : letters.increment(
                                                localStorage.getItem("letter")
                                              )}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <div class="custom-async-select">
                                          <Async
                                            name="fabricNumber"
                                            value={value.fabricId}
                                            onInputChange={this.getFabrics}
                                            onChange={data =>
                                              this.__handleChange(
                                                "fabricId",
                                                data,
                                                index
                                              )
                                            }
                                            placeholder="Search Fabric"
                                            options={fabricInfo}
                                            disabled={this.state.disabled}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div class="">
                                          <div class="input-group-append">
                                            <span class="input-group-text p-1 font-apply-li">
                                              {localStorage.getItem("letter")}
                                            </span>
                                          </div>
                                          <div class="custom-async-select">
                                            <Async
                                              name="greigeMill"
                                              value={value.greigeMill}
                                              // onInputChange={
                                              //   this.getGreigeBStyleNo
                                              // }
                                              onChange={data =>
                                                this.__handleChange(
                                                  "greigeMill",
                                                  data,
                                                  index
                                                )
                                              }
                                              placeholder="Select Greige Mill"
                                              options={
                                                bnumberOptions.GREIGEMILL
                                              }
                                              disabled={this.state.disabled}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div class="">
                                          <div class="input-group-append">
                                            <span class="input-group-text p-1 font-apply-li">
                                              {localStorage.getItem("letter")}
                                            </span>
                                          </div>
                                          <div class="custom-async-select">
                                            <Async
                                              name="processMill"
                                              value={value.processMill}
                                              // onInputChange={
                                              //   this.getProcessBStyleNo
                                              // }
                                              onChange={data =>
                                                this.__handleChange(
                                                  "processMill",
                                                  data,
                                                  index
                                                )
                                              }
                                              placeholder="Select Process Mill"
                                              options={
                                                bnumberOptions.PROCESSMILL
                                              }
                                              disabled={this.state.disabled}
                                            />
                                          </div>
                                        </div>
                                      </td>

                                      <td>
                                        {!this.state.disabled && (
                                          <Button
                                            buttonType="remove"
                                            onClick={() =>
                                              this.decreasebNumberRefernce(
                                                index
                                              )
                                            }
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div class="col-md-12 col step-one">
                            <FileUpload
                              Heading="Upload Images"
                              moduleName={"bnumber"}
                              getRefImages={this.getRefImages}
                              disabled={this.state.disabled}
                              uploadedDocs={
                                this.state.action === "edit" ||
                                  this.state.action === "view"
                                  ? this.state.bNumber.refImages
                                  : null
                              }
                            />
                          </div>
                          <div class="col-md-12 profile-btn text-center p-2 ">
                            <Button
                              buttonName={"save"}
                              onClick={this.addBNumber}
                            />
                            <Button
                              buttonType={"cancel"}
                              buttonName={"Cancel"}
                              history={this.props.history}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <Modal
            open={this.state.openModal}
            onClose={() => this.setState({ openModal: false })}
            s
            center
          >
            <img
              src={
                this.state.imageForModal !== "" &&
                window.URL.createObjectURL(this.state.imageForModal)
              }
              style={{ width: "100%" }}
            />
          </Modal>
        </Fragment>
      )
    } else {
      return <Loading />
    }
  }
}

export default DevelopmentBNumber


// WEBPACK FOOTER //
// ./src/pages/developmentBNumber/page.js